const LoadingIconRed = () => {
    
    return (
        <div className="lds-ring-red pb-4">
            <div></div><div></div><div></div>
        </div>
    )
}

export default LoadingIconRed;